"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDropDown = void 0;
var React = require("react");
var react_1 = require("react");
var Dropdown_1 = require("office-ui-fabric-react/lib/Dropdown");
exports.CustomDropDown = function (_a) {
    var placeholder = _a.placeholder, label = _a.label, data = _a.data, additives = _a.additives, additivesChangedEvent = _a.additivesChangedEvent;
    var _b = react_1.useState(additives ? additives.map(function (x) { return x.key; }) : []), selectedKeys = _b[0], setSelectedKeys = _b[1];
    react_1.useEffect(function () {
        additivesChangedEvent(data.filter(function (ele) { return selectedKeys.includes(ele.key); }));
    }, [selectedKeys]);
    var onChange = function (event, item) {
        if (item) {
            setSelectedKeys(item.selected ? __spreadArrays(selectedKeys, [item.key]) : selectedKeys.filter(function (key) { return key !== item.key; }));
        }
    };
    return (React.createElement(Dropdown_1.Dropdown, { placeholder: placeholder, label: label, selectedKeys: selectedKeys, 
        // eslint-disable-next-line react/jsx-no-bind
        onChange: onChange, multiSelect: true, options: data }));
};
//# sourceMappingURL=CustomDropDown.js.map